<template>
    <ul class="paginator">
        <slot></slot>
    </ul>
</template>

<script>
    export default {
        name: 'Paginator',
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';

    .paginator {
        $padding: 1rem;

        display: flex;

        justify-content: center;

        margin-bottom: 5rem;

        list-style: none;

        &__item {
            display: flex;

            font-size: 1.8rem;

            &::before {
                content: '–';
                display: flex;
            }

            // No separator needed before the previous & next arrows nor the first item
            &:nth-child(1),
            &:nth-child(2),
            &:last-child {
                &::before {
                    content: none;
                }
            }
        }

        &__item-inner {
            display: flex;

            padding: 0 $padding;

            color: $body-color;

            transition: all 100ms ease-in-out;

            .paginator__item--current > & {
                position: relative;
                color: $color-brand;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0.3rem;
                    left: $padding;
                    right: $padding;

                    border-bottom: 0.1rem solid currentColor;
                }
            }

            :not(.paginator__item--current) > & {
                &:hover,
                &:focus {
                    background: lighten($color-brand, 55);
                }
            }
        }
    }
</style>
